<script lang="ts">
  import RichAlert from '@packages/ui/main/rich-alert/RichAlert.svelte'
  import { pageOptsStore } from '@packages/stores'
  import { onDestroy } from 'svelte'
  import { type TRichAlertButtonConfig } from '@packages/utils/types'

  let richAlertData: {
    description: string
    title: string
    action?: TRichAlertButtonConfig,
    closeButtonText?: string
  }

  const unsub = pageOptsStore.subscribe((data) => {
    richAlertData = { ...richAlertData, ...data.richAlertData }
  })

  onDestroy(unsub)
</script>

<RichAlert
  options={{
    title: richAlertData.title || 'Notification',
    description: richAlertData.description || 'Choose your next steps',
    action: richAlertData.action,
    closeButtonText: richAlertData.closeButtonText
  }}
/>
